(() => {
  const initSection = (section) => {
    if (!section || !section.classList.contains('anchor-tab-nav-section')) return;

    const nav = section.querySelector('.atn__tabs');
    if (!nav) return;

    const offset = parseInt(nav.dataset.atnOffset, 10) || 0;
    const links = Array.from(section.querySelectorAll('.atn__tab'));

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.dataset.atnTarget;
        const targetEl = targetId && document.getElementById(targetId);
        if (!targetEl) return;

        event.preventDefault();
        const top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });

        if (history.pushState) {
          history.pushState(null, '', `#${targetId}`);
        }
      });
    });

    const targets = links
      .map((link) => document.getElementById(link.dataset.atnTarget))
      .filter(Boolean);

    if (targets.length && 'IntersectionObserver' in window) {
      const setActive = (id) => {
        links.forEach((link) => {
          link.classList.toggle('atn__tab--active', link.dataset.atnTarget === id);
        });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActive(entry.target.id);
            }
          });
        },
        { rootMargin: `-${offset + 10}px 0px -70% 0px`, threshold: 0 }
      );

      targets.forEach((target) => observer.observe(target));
    }
  };

  document.querySelectorAll('.anchor-tab-nav-section').forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
})();
